import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: `"Inter", "sans-serif"`,
  },
});

export default theme;
